import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, Cidade, DadosCNPJ, Estado, InputsRefs, ParceiroAttributes, RetAPI, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark, classBt,
    classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classbtAzul,
    classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, focusLabelRed, focusRed
} from '../../Utils/Types'
import { IoSave } from 'react-icons/io5'
import InputMask from 'react-input-mask'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { Link, useParams } from 'react-router-dom'
import { ParceiroService } from './ParceiroService'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { ModalConsultaCNPJ } from '../../Components/ModalConsultaCNPJ/modal-consulta-cnpj'
import { UtilServices } from '../../Utils/UtilServices'
import { Funcoes } from '../../Utils/Funcoes'
import { FcNook } from 'react-icons/fc'
import { cnpj } from 'cpf-cnpj-validator'
import { AiOutlineClear } from 'react-icons/ai'
import { Tooltip } from 'react-tooltip'
import { FaRegQuestionCircle } from 'react-icons/fa'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const ParceirosNewPage = () => {

    // SEM USO -----------------------------------------------------------------------------------------------
    /*
    //const [templateLoading, setTemplateLoading] = useState<boolean>(false)
    //const [labelPessoa, setLabelPessoa] = useState("CPF")
    //const [maskDoc, setMaskDoc] = useState("999.999.999-99")
    //const [btNovoVisible, setBtNovoVisible] = useState<boolean>(true)
    //const [idParceiro, setIdParceiro] = useState("")
    */

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'razao', erro: false },           // Posição 0 do Array.
        { campo: 'nome_fantasia', erro: false },   // Posição 1 do Array.
        { campo: 'endereco', erro: false },        // Posição 2 do Array.
        { campo: 'cidade', erro: false },          // Posição 3 do Array. 
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { id_parceiro } = useParams<string>()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<ParceiroAttributes>()

    // COLUNA 1
    const [tipoPessoa, setTipoPessoa] = useState("F")
    const [cpfCnpj, setCpfCnpj] = useState("")
    const [nomeRazao, setNomeRazao] = useState("")
    const [nomeRazaoCopia, setNomeRazaoCopia] = useState("")
    const [nome_fantasia, setNomeFantasia] = useState("")
    const [email, setEmail] = useState("")
    const [contato, setContato] = useState("")
    const [fone, setFone] = useState("")
    const [celular, setCelular] = useState("")
    const [ieRg, setIeRg] = useState("")
    const [ativo, setAtivo] = useState("S")
    const [observacao, setObservacao] = useState("")

    // COLUNA 2
    const [cep, setCep] = useState("")
    const [endereco, setEndereco] = useState("")
    const [bairro, setBairro] = useState("")
    const [numero, setNumero] = useState("")
    const [complemento, setComplemento] = useState("")
    const [idUf, setIdUf] = useState(0)
    const [siglaUf, setSiglaUf] = useState("")
    const [uf, setUf] = useState<Estado[]>([])
    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- MODALS --------------------------------------------------------------
    const [modalConsultaVisible, setModalConsultaVisible] = useState(false)

    // --------- lOADING --------------------------------------------------------------
    const [loadingCnpj, setLoadingCnpj] = useState<boolean>(false)
    const [loadingConsultaCEP, setLoadingConsultaCEP] = useState<boolean>(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const dadosEmpresaLogada = () => {

        const dadosEmpresa = Funcoes.GetDadosEmpresa()

        if (dadosEmpresa !== null) {

            const dadosLocalStorage = dadosEmpresa

            const ufEmpresa = dadosLocalStorage.uf

            const estado = [...attributes?.estados || []].filter((uf) => uf.sigla === ufEmpresa)

            if (estado && estado.length > 0) {
                setIdUf(estado[0].id)
                setarCidades(estado[0].sigla)
                setSiglaUf(estado[0].sigla)

            }
        }
    }

    const GetAttributes = async () => {

        setLoading(true)

        try {

            const attributes = await ParceiroService.GetAttributes(id_parceiro)

            setAttributes(attributes.data)
            setUf(attributes.data.estados)
            //setCidade(attributes.cidades)

            const dadosEmpresa = Funcoes.GetDadosEmpresa()

            if (dadosEmpresa !== null) {

                const dadosLocalStorage = dadosEmpresa

                const ufEmpresa = dadosLocalStorage.uf

                const estado = attributes.data.estados.filter((uf: any) => uf.sigla === ufEmpresa)

                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }
            }

            if (attributes.data && id_parceiro) {

                const citys = attributes.data.cidades.filter((item: any) => item.id === attributes.data.parceiros?.id_cidade)
                if (citys && citys.length > 0) {
                    setIdCity(citys[0].id)
                }

                const estado = attributes.data.estados.filter((uf: any) => uf.sigla === attributes.data.parceiros?.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                }

                setId(attributes.data.parceiros.id || 0)
                setTipoPessoa(attributes.data.parceiros.tipo_pessoa || 'F')
                setCpfCnpj(attributes.data.parceiros.cnpj_cpf || '')
                setNomeRazao(attributes.data.parceiros.razao)
                setNomeRazaoCopia(attributes.data.parceiros.razao)
                setNomeFantasia(attributes.data.parceiros.nome_fantasia)
                setIeRg(attributes.data.parceiros.ie_rg || '')
                setAtivo(attributes.data.parceiros.ativo ? "S" : "N")
                setObservacao(attributes.data.parceiros.observacao || '')
                setCep(attributes.data.parceiros.cep?.toString() || '')
                setEndereco(attributes.data.parceiros.endereco)
                setBairro(attributes.data.parceiros.bairro || '')
                setNumero(attributes.data.parceiros.numero?.toString() || '')
                setComplemento(attributes.data.parceiros.complemento || '')
                setContato(attributes.data.parceiros.contato || '')
                setFone(attributes.data.parceiros.telefone || '')
                setCelular(attributes.data.parceiros.celular || '')
                setEmail(attributes.data.parceiros.email || '')
                setSiglaUf(attributes.data.parceiros.uf || '')

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        GetAttributes()
        inputFocus()
    }, [])

    useEffect(() => {
        const newCitys = attributes?.cidades.filter((item: Cidade) => {
            return item.uf === (attributes?.parceiros.uf || siglaUf)
        })

        setCidade(newCitys || [])

    }, [attributes])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const tipoPessoaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoPessoa(e.target.value)
    }

    const cpfCnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '')
        setCpfCnpj(inputValue)
    }

    const nomeRazaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeRazao(e.target.value)
    }

    const fantasiaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeFantasia(e.target.value)
    }

    const emailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const contatoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContato(e.target.value)
    }

    const ieRgChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIeRg(e.target.value)
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
    }

    const telefoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFone(e.target.value)
    }

    const celularChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCelular(e.target.value)
    }

    const observacaoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    const cepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('_', '').replaceAll('-', '')
        setCep(inputValue)

        if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 8) {
            handleConsultaCEP(e.target.value)

        } else if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 0) {

            setEndereco('')
            setBairro('')
            setNumero('')
            setComplemento('')
            setIdCity(0)
            dadosEmpresaLogada()

            updateUfList()
        }
    }

    const handleConsultaCEP = async (cep: string) => {

        setVisible(false)
        setLoadingConsultaCEP(true)

        try {

            const dadosCEP = await Funcoes.ConsultaCEP(cep)

            if (dadosCEP.error) {

                dadosEmpresaLogada()
                setIdCity(0)
                setBairro('')
                setComplemento('')
                setEndereco('')

            } else {

                updateUfList()

                const estado = [...attributes?.estados || []].filter((item) => item.sigla === dadosCEP.data.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }

                const cidade = [...attributes?.cidades || []].filter((item) => item.id === dadosCEP.data.ibge)
                if (cidade && cidade.length > 0) {
                    setIdCity(cidade[0].id)
                }

                setBairro(dadosCEP.data.bairro)
                setComplemento(dadosCEP.data.complemento)
                setEndereco(dadosCEP.data.logradouro)

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível consultar o CEP. Por favor, tente novamente`)

        } finally {
            setLoadingConsultaCEP(false)
        }
    }

    const enderecoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndereco(e.target.value)
    }

    const bairroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBairro(e.target.value)
    }

    const numeroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const complementoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComplemento(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ESTADO --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUfSelecionada = useCallback(() => {
        setSiglaUf("")
        setIdUf(0)

        updateUfList()

        setCidade([])
        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description === "") {
            updateUfList()
        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }
    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()

        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const updateUfList = () => {
        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CIDADE --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCidadeSelecionada = useCallback(() => {
        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        if (idUf === 0) {
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            setIdCity(0)
        }
        */
    }, [uf, siglaUf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            setarCidades(siglaUf)
            //const newCidadeList = [...attributes?.cidades || []]
            //setCidade(newCidadeList)

        } else {

            let newCidadeList = []

            newCidadeList = [...attributes?.cidades || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                    item.uf === siglaUf
            })

            setCidade(newCidadeList)

            /*
            if (idUf > 0) {
                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                        item.uf === siglaUf
                })
    
            } else {
    
                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase())
                })
            }
            */
        }
    }, [uf, siglaUf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {

        if (v) {
            setIdCity(v.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
        // setIdCidade(v.codIBGE)
    }, [uf, siglaUf])

    const setarCidades = async (uf: string) => {
        const citys = await attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- PARCEIROS ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoParceiro = () => {

        //const newCidadeList = [...attributes?.cidades || []]
        //setCidade(newCidadeList)

        setId(0)
        setTipoPessoa("F")
        setCpfCnpj("")
        setNomeRazao("")
        setNomeFantasia("")
        setEmail("")
        setContato("")
        setIeRg("")
        setAtivo("S")
        setFone("")
        setCelular("")
        setObservacao("")

        setCep("")
        setEndereco("")
        setBairro("")
        setNumero("")
        setComplemento("")
        setIdCity(0)

        updateUfList()
        dadosEmpresaLogada()

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        redefinirCampos()
        inputFocus()
    }

    const handleSaveParceiro = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)

        try {

            let params = {
                id: id,
                razao: nomeRazao,
                nome_fantasia: nome_fantasia,
                endereco: endereco,
                bairro: bairro,
                cep: cep != '' && cep.length === 8 ? Funcoes.FormatCep(cep) : '',
                id_cidade: idCity,
                tipo_pessoa: tipoPessoa,
                cnpj_cpf: cpfCnpj ? Funcoes.FormatDoc(cpfCnpj) : '',
                ie_rg: ieRg,
                complemento: complemento,
                observacao: observacao,
                ativo: ativo,
                numero: numero,
                contato: contato,
                celular: celular,
                telefone: fone,
                email: email
            }

            if (cep.length > 0 && cep.length < 8) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`CEP digitado inválido`)
                    clearTimeout(timer)
                }, 250)

                return
            }

            const resp: RetAPI = await ParceiroService.Save(params)

            if (resp.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios(resp.field || '')

            } else {
                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados do parceiro atualizados com sucesso` : resp.msg || ``)

                setNomeRazaoCopia(resp.data.parceiro.razao)
                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados do parceiro. Por favor, tente novamente` : `Não foi possível salvar os dados do parceiro. Por favor, tente novamente`)


        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const abrirModalConsultaCNPJ = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setModalConsultaVisible(true)
        searchBoxFocus()
    }

    const fecharModalConsultaCNPJ = useCallback(() => {
        setVisible(false)
        setModalConsultaVisible(false)
        inputFocus()
    }, [])

    const inputFocusCNPJ = () => {
        const inputElement = document.getElementById("inputCNPJ")
        inputElement?.focus()
    }

    const handleConsultarCNPJ = useCallback(async (CNPJ: string) => {

        setVisible(false)
        setLoadingCnpj(true)

        try {

            if (CNPJ !== '' && cnpj.isValid(CNPJ)) {

                const dadosCNPJ: DadosCNPJ = await UtilServices.ConsultarCNPJ(CNPJ)

                if (dadosCNPJ.razao) {

                    updateUfList()

                    setNomeRazao(dadosCNPJ.razao || '')
                    setNomeFantasia(dadosCNPJ.fantasia || dadosCNPJ.razao)
                    setEndereco(dadosCNPJ.logradouro || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setNumero(dadosCNPJ.numero?.toString() || '')
                    setCep(dadosCNPJ.cep.replaceAll('.', '').replaceAll('-', '') || '')
                    setComplemento(dadosCNPJ.compl || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setCpfCnpj(dadosCNPJ.cnpj.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '') || '')
                    setSiglaUf(dadosCNPJ.uf || '')
                    setarCidades(dadosCNPJ.uf || '')
                    setIdUf(dadosCNPJ.id_uf || 0)
                    setIdCity(dadosCNPJ.id_cidade || 0)
                    setAtivo('S')
                    setTipoPessoa('J')
                    setModalConsultaVisible(false)

                } else {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Erro ao localizar CNPJ`)

                    inputFocusCNPJ()

                }

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`CNPJ inválido`)
                    setLoadingCnpj(false)

                    inputFocusCNPJ()
                    clearTimeout(timer)
                }, 250)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível consultar o CNPJ. Por favor, tente novamente`)

            inputFocusCNPJ()

        } finally {
            setLoadingCnpj(false)
        }

    }, [attributes?.estados])

    const checkDadosObrigatorios = (field: string): boolean => {

        /*
        if (cpfCnpj.trim() === '' || (tipoPessoa === 'F' && (!(cpf.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("_", "").length === 11))) || (tipoPessoa === 'J' && (!(cnpj.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", "").length === 14)))) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }
        */

        if (nomeRazao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (nome_fantasia.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        /*
        if (ieRg.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }
        */

        if (endereco.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        /*
        if (bairro.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }
        */

        if (siglaUf.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (idCity <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'razao', erro: false },           // Posição 0 do Array.
            { campo: 'nome_fantasia', erro: false },   // Posição 1 do Array.
            { campo: 'endereco', erro: false },        // Posição 2 do Array.
            { campo: 'cidade', erro: false },          // Posição 3 do Array. 
        ]

        setCamposObrigatorios(fieldsM)
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("cnpj_cpf")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ---------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        tipoPessoa: useRef(null),
        cpfCnpj: useRef(null),
        nomeRazao: useRef(null),
        nomeFantasia: useRef(null),
        email: useRef(null),
        contato: useRef(null),
        ieRg: useRef(null),
        ativo: useRef(null),
        telefone: useRef(null),
        celular: useRef(null),
        observacao: useRef(null),
        cep: useRef(null),
        logradouro: useRef(null),
        bairro: useRef(null),
        numero: useRef(null),
        complemento: useRef(null),
        uf: useRef(null),
        cidade: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 16) {
                setVisibleSearchBoxUF(true)
                inputFocusUF()
            }

            if (nextIndex === 17) {
                setVisibleSearchBoxCity(true)
                inputFocusCidade()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                event.preventDefault()

                const inputSearchUf = document.getElementById('inputSearchBox-uf') as HTMLInputElement
                const inputSearchCidade = document.getElementById('inputSearchBox-cidade') as HTMLInputElement

                if (document.activeElement === inputSearchUf) {

                    clickSearchBoxCidade()
                    setVisibleSearchBoxUF(false)

                } else if (document.activeElement === inputSearchCidade) {
                    inputsRefs['tipoPessoa'].current?.focus()
                    setVisibleSearchBoxCity(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [])

    const searchBoxFocus = () => {
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
    }

    // UF
    const boxFocusUF = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['uf'].current?.focus()
    }

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false) // Fecha o City ao abrir UF
                inputFocusUF() // Foca no input UF ao abrir
            }
            return newState
        })

        boxFocusUF() // Sempre executa ao clicar
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-uf`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CIDADE
    const boxFocusCidade = () => {
        // Move o foco para o input correspondente à chave 'cidade'.
        inputsRefs['cidade'].current?.focus()
    }

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxUF(false) // Fecha o UF ao abrir City
                inputFocusCidade() // Foca no input Cidade ao abrir
            }
            return newState
        })

        boxFocusCidade() // Sempre executa ao clicar
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidade`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ------------------------------------------------- CÓDIGOS SEM USO ------------------------------------------------------------
    const handleChangeCidade = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setIdCidade(parseInt(e.target.value))
    }

    const handleChangeUF = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setUF(e.target.value)
        //FilterCidade(e.target.value)
    }

    const handleChangeLabelPessoa = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //setLabelPessoa(e.target.value)
    }

    const filterCidade = async () => {
        //const newCidadeList = [...attributes.cidades]
        //setCidades(await newCidadeList.filter((cidade) => cidade.uf.trim() === uf.trim()))
    }

    const maskTipoPessoa = tipoPessoa != '' && tipoPessoa === 'F' ? '999.999.999-99' : '99.999.999/9999-99'
    const ativoEdit = parseInt(id_parceiro || '0') > 0 ? false : true
    const btNovoVisible = parseInt(id_parceiro || '0') > 0 ? 'invisible hidden' : 'visible'

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody} `}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}>{parseInt(id_parceiro || '') || id > 0 ? `Editar - Parceiro - ${nomeRazaoCopia}` : 'Cadastro - Parceiro'}</span>
                        </div>

                        <div className={`relative`}>

                            <div className={`flex flex-col sm:flex-row`}>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados Pessoais</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-5 md:col-span-4 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <select ref={inputsRefs.tipoPessoa} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'tipoPessoa')} id='tipoPessoa' className={`${classInput} ${classInputDark}`} value={tipoPessoa} onFocus={searchBoxFocus} onChange={tipoPessoaChange}>
                                            <option value="F">Física</option>
                                            <option value="J">Jurídica</option>
                                        </select>
                                        <label htmlFor="tipoPessoa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Pessoa</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-7 md:col-span-8 xl:col-span-5`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <InputMask ref={inputsRefs.cpfCnpj} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cpfCnpj')} id="cnpj_cpf" mask={maskTipoPessoa} className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' placeholder=' ' autoComplete="off" value={cpfCnpj} onFocus={searchBoxFocus} onChange={cpfCnpjChange} />
                                        <label htmlFor="cnpj_cpf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipoPessoa !== '' && tipoPessoa === 'F' ? `CPF` : `CNPJ`}</label>
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${nomeRazao != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.nomeRazao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeRazao')} id="nomeRazao" className={`${classInput} ${classInputDark} ${nomeRazao != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} placeholder=' ' autoComplete="off" value={nomeRazao} onFocus={searchBoxFocus} onChange={nomeRazaoChange} />
                                        <label htmlFor="nomeRazao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeRazao != '' ? '' : focusLabelRed}`}>{tipoPessoa !== '' && tipoPessoa === 'F' ? `Nome` : `Razão Social`}</label>
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${nome_fantasia != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.nomeFantasia} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeFantasia')} id="nome_fantasia" className={`${classInput} ${classInputDark} ${nome_fantasia != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} placeholder=' ' autoComplete="off" value={nome_fantasia} onFocus={searchBoxFocus} onChange={fantasiaChange} />
                                        <label htmlFor="nome_fantasia" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nome_fantasia != '' ? '' : focusLabelRed}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? `Apelido` : `Nome Fantasia`}</label>
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.email} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'email')} id="email" className={`${classInput} ${classInputDark} disabled:bg-gray-100`} type='email' inputMode='email' maxLength={155} placeholder=' ' autoComplete="off" value={email} onFocus={searchBoxFocus} onChange={emailChange} />
                                        <label htmlFor="email" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>E-mail</label>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-8`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.contato} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'contato')} id="contato" className={`${classInput} ${classInputDark} disabled:bg-gray-100`} type='text' inputMode='text' maxLength={100} placeholder=' ' autoComplete="off" value={contato} onFocus={searchBoxFocus} onChange={contatoChange} />
                                        <label htmlFor="contato" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Contato</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${tipoPessoa === 'F' ? bgBlue : ieRg == '' && tipoPessoa === 'J' ? bgRed : bgBlue}`} />
                                        <input ref={inputsRefs.ieRg} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ieRg')} id="insc_estadual" className={`${classInput} ${classInputDark} ${ieRg == '' && tipoPessoa === 'J' ? focusRed : ``}`} type='text' inputMode='text' maxLength={45} placeholder=' ' autoComplete="off" value={ieRg} onFocus={searchBoxFocus} onChange={ieRgChange} />
                                        <label htmlFor="insc_estadual" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${ieRg == '' && tipoPessoa === 'J' ? focusLabelRed : ``}`}>{tipoPessoa === 'J' ? 'Insc. Estadual' : 'RG'}</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} ${ativoEdit ? `opacity-50` : ``}`} />
                                        <select ref={inputsRefs.ativo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ativo')} id="ativo" disabled={ativoEdit} className={`${classInput} ${classInputDark} ${parseInt(id_parceiro || '0') > 0 ? `cursor-pointer` : `cursor-not-allowed`} `} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                            <option value="S">Sim</option>
                                            <option value="N">Não</option>
                                        </select>
                                        <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                                    </div>

                                    <div className={`relative w-full col-span-12 sm:col-span-6 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <InputMask ref={inputsRefs.telefone} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'telefone')} id="fone" className={`${classInput} ${classInputDark} disabled:bg-gray-100`} type='tel' inputMode='tel' placeholder=' ' autoComplete="off" value={fone} onFocus={searchBoxFocus} onChange={telefoneChange} mask="(99) 9999-9999" alwaysShowMask={true} />
                                        <label htmlFor="fone" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Telefone</label>
                                    </div>

                                    <div className={`relative w-full col-span-12 sm:col-span-6 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <InputMask ref={inputsRefs.celular} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'celular')} id="celular" className={`${classInput} ${classInputDark} disabled:bg-gray-100`} type='tel' inputMode='tel' placeholder=' ' autoComplete="off" value={celular} onFocus={searchBoxFocus} onChange={celularChange} mask="(99) 99999-9999" alwaysShowMask={true} />
                                        <label htmlFor="celular" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Celular</label>
                                    </div>

                                    <div className={`relative w-full col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                        <textarea ref={inputsRefs.observacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'observacao')} id='obsParceiro' className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} value={observacao} onFocus={searchBoxFocus} onChange={observacaoChange} />
                                        <label htmlFor="obsParceiro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                </div>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4 sm:h-[50px]`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Endereço</span>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <div className='absolute h-full flex items-center px-2'>

                                            {loadingConsultaCEP &&
                                                <div className={`absolute h-[20px] w-[20px] animate-spin rounded-full ml-1 border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }

                                        </div>
                                        <InputMask ref={inputsRefs.cep} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cep')} id="cep" className={`${classInput} ${classInputDark} ${loadingConsultaCEP ? 'pl-10' : ''}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cep} onFocus={searchBoxFocus} onChange={cepChange} mask={'99999-999'} alwaysShowMask={true} />
                                        <label htmlFor="cep" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Cep</label>

                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${endereco != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.logradouro} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'logradouro')} id="endereco" className={`${classInput} ${classInputDark} ${endereco != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} placeholder=' ' autoComplete="off" value={endereco} onFocus={searchBoxFocus} onChange={enderecoChange} />
                                        <label htmlFor="endereco" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${endereco != '' ? '' : focusLabelRed}`}>Logradouro</label>
                                    </div>

                                    <div className={`relative col-span-12 lg:col-span-8 xl:col-span-6`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.bairro} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'bairro')} id="bairro" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={155} placeholder=' ' autoComplete="off" value={bairro} onFocus={searchBoxFocus} onChange={bairroChange} />
                                        <label htmlFor="bairro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Bairro</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.numero} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'numero')} id="numero" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={40} placeholder=' ' autoComplete="off" value={numero} onFocus={searchBoxFocus} onChange={numeroChange} />
                                        <label htmlFor="numero" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 md:col-span-8 lg:col-span-5 xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.complemento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'complemento')} id="complemento" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={60} placeholder=' ' autoComplete="off" value={complemento} onFocus={searchBoxFocus} onChange={complementoChange} />
                                        <label htmlFor="complemento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Complemento</label>
                                    </div>

                                    <div className={`relative col-span-12 lg:col-span-7 xl:col-span-6`}>

                                        <div ref={inputsRefs['uf']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'uf')} />
                                        <div className={`${barraVermelhoAzul} ${idUf > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={uf}
                                            idRegistro={idUf || undefined}
                                            label='Estado'
                                            componentId='uf'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxUF}
                                            clearDataClick={handleClearUfSelecionada}
                                            setDataClick={handleUfSelectClick}
                                            filterDataClick={handleFilterUfClick}
                                            clicado={clickSearchBoxUF}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-6`}>

                                        <div ref={inputsRefs['cidade']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cidade')} />
                                        <div className={`${barraVermelhoAzul} ${idCity > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={cidade}
                                            idRegistro={idCity || undefined}
                                            label='Cidade'
                                            componentId='cidade'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxCity}
                                            clearDataClick={handleClearCidadeSelecionada}
                                            setDataClick={handleCidadeSelectClick}
                                            filterDataClick={handleFilterCidadeClick}
                                            clicado={clickSearchBoxCidade}
                                        />
                                    </div>

                                </div>

                            </div>

                            <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                <div className={`flex flex-col lg:flex-row ${parseInt(id_parceiro || '0') > 0 ? `sm:space-y-0 lg:space-x-0 space-y-1` : `lg:space-y-0 lg:space-x-4 space-y-4`}`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/parceiros" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={abrirModalConsultaCNPJ} className={` ${parseInt(id_parceiro || '') > 0 || id > 0 ? `invisible hidden` : `visible`} ${classbtColunasAzul} ${classWeigthBt}`}>
                                        <span>Consultar CNPJ</span>
                                    </button>

                                </div>

                                <div className={`flex flex-col lg:flex-row ${parseInt(id_parceiro || '0') > 0 ? `sm:space-y-0 lg:space-x-0 space-y-1` : `lg:space-y-0 lg:space-x-4 space-y-4`}`}>

                                    <button tabIndex={-1} onClick={novoParceiro} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`mr-[5px]`} /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveParceiro} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(id_parceiro || '0') > 0 || id !== 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                    <ModalConsultaCNPJ
                        visible={modalConsultaVisible}
                        loading={loadingCnpj}
                        CloseModalEvent={fecharModalConsultaCNPJ}
                        ConsultarCNPJEvent={handleConsultarCNPJ}
                    />

                </div>

            </div>

        </Template>

    )
}